<template>
  <div class="side-bar sticky flex shrink-0 flex-col bg-white rounded py-5 h-full w-311px xl:w-512px transition-top overflow-auto no-scrollbar">
    <div class="hero-image relative px-5">
      <etg-img class="w-full aspect-1.8 object-cover rounded" :src="`fn:${branch?.cover_image}`" :alt="branch?.name" />
      <div class="overlay absolute top-0 left-0 w-full h-full z-10 pointer-events-none">
        <!-- <favorite-button :id="branch?.pid!" :is-favorited="branch?.is_favorite || false" class="absolute top-2 right-2 pointer-events-auto" /> -->
      </div>
    </div>
    <product-section-reservation :arrival-times="props.arrivalTimes" />

    <reservation-summary class="summary-bar -mb-5 px-5 py-6" />
  </div>
</template>

<script setup lang="ts">
// import FavoriteButton from '@/components/common/favorite-button.vue'
import ReservationSummary from '@/components/reservation/reservation-summary.vue'
import ProductSectionReservation from '@/components/product/product-detail/product-section-reservation.vue'

import type { BranchArrivalTimeInfo } from '@/types/api'

const props = defineProps<{
  arrivalTimes?: Nullable<BranchArrivalTimeInfo>
}>()

const { branch } = useBranchDetailContext()
</script>

<style lang="scss" scoped>
.summary-bar {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
}

.side-bar {
  &:not(:hover) {
    :deep(.list-arrow) {
      @apply opacity-0;
    }
  }
}
</style>
